"use client";

import { useSyncExternalStore } from "react";

const noopSubscribe = () => () => {};

/**
 * Returns `false` in the server render and during hydration, `true` once
 * React has hydrated on the client.
 *
 * Use it to keep controls inert until their event handlers are attached
 * (e.g. auth forms, which would otherwise native-submit as a GET). It is
 * also the pattern for clock- or locale-dependent text that the server must
 * not guess, instead of `suppressHydrationWarning`.
 *
 * Text that has to be on the first paint and stay unchanged (the home
 * greeting) needs a value the server can already render, such as the `tz`
 * cookie. Deferring that text until this hook flips is what makes the
 * heading change after hydration.
 */
export function useHydrated(): boolean {
  return useSyncExternalStore(
    noopSubscribe,
    () => true,
    () => false,
  );
}
